const id_sales_refItemIn = {
    error: {
        reject: "Gagal membatalkan DO IN.",
    },

    success: {
        reject: "Berhasil membatalkan DO IN.",
    },
}

export default id_sales_refItemIn;